

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://cd2c8e8d2a11492b9ae615ed62ef6072@sentry.wixpress.com/3606", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/src/components/WixRatingsSummary/Widget/index.tsx';
    import createController from '/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/src/components/WixRatingsSummary/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  import * as viewerApp from '/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/src/viewer.app.ts';
    var importedApp = viewerApp;

    var componentName = 'WixRatingsSummary';
    var projectName = 'wix-reviews';
    var sentryConfig = {
      DSN: 'https://cd2c8e8d2a11492b9ae615ed62ef6072@sentry.wixpress.com/3606',
      id: 'ddac5f9ae34511ec9fff0242ac12001c',
      projectName: 'wix-reviews',
      teamName: 'forum',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/src/components/WixRatingsSummary/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"scopes":["todo-viewer-apps-95a5fce-e370-4402-9ce4-96956acc747d"],"centralized":true};
    var fedopsConfig = null;
    var translationsConfig = {"enabled":true,"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hu","id","it","ja","ko","lt","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"ratings-widget.full-label":"{rating} | {count, plural, =0 {reviews} one {# review} other {# reviews}}","ratings-widget.compact-label":"{rating} ({count})","ratings-widget.empty.no-reviews":"No reviews","ratings-widget.aria-label":"Rating is {rating} out of five stars based on {count, plural, =0 {reviews} one {# review} other {# reviews}}","ratings-settings.tab.display":"Display","ratings-settings.tab.design":"Design","ratings-settings.empty-state-label.title":"If a product has no reviews, show:","ratings-settings.empty-state-label.blank":"Blank empty state","ratings-settings.empty-state-label.plain-text":"Empty state with a message","ratings-settings.reset-to-original-design":"Reset to original design","ratings-settings.active-star-color.label":"Filled star opacity & color","ratings-settings.inactive-star-color.label":"Unfilled star opacity & color","ratings-settings.score-font.label":"Score text font & color","ratings-settings.score-font-size.label":"Score font size","ratings-settings.widget-alignment.label":"Widget alignment","ratings-settings.panel-title.font-and-color-picker":"Font","ratings-settings.custom-font-label.font-and-color-picker":"Custom","ratings-settings.star-size.label":"Star size (px)"};
    var styleHocConfig = {"enabled":true};
    var biConfig = {"enableUniversalEvents":true};
    var appDefinitionId = "a95a5fce-e370-4402-9ce4-96956acc747d";
    var componentId = "9c715d36-22f7-4633-b730-e73489729977";
    var localeDistPath = 'components/WixRatingsSummary/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/7316bfa601ecc640/reviews-web/wix-reviews/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
